import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Clock, Mail, User } from 'lucide-react';

export const RecentActivity = ({ contacts }) => {
  // Get 5 most recent contacts
  const recent = [...contacts]
    .sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp))
    .slice(0, 5);

  const getTimeAgo = (timestamp) => {
    const now = new Date();
    const past = new Date(timestamp);
    const diffMs = now - past;
    const diffMins = Math.floor(diffMs / 60000);
    const diffHours = Math.floor(diffMs / 3600000);
    const diffDays = Math.floor(diffMs / 86400000);

    if (diffMins < 60) return `Il y a ${diffMins} min`;
    if (diffHours < 24) return `Il y a ${diffHours}h`;
    return `Il y a ${diffDays}j`;
  };

  return (
    <Card className="bg-light/5 border-gold/20">
      <CardHeader>
        <CardTitle className="text-white flex items-center gap-2">
          <Clock className="w-5 h-5 text-gold" />
          Activité Récente
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-3">
        {recent.length === 0 ? (
          <p className="text-gray-400 text-center py-4 text-sm">
            Aucune activité récente
          </p>
        ) : (
          recent.map((contact) => (
            <div
              key={contact.id}
              className="bg-white/5 p-3 rounded-sm border border-gold/10 hover:border-gold/30 transition-colors"
            >
              <div className="flex items-start justify-between mb-2">
                <div className="flex items-center gap-2">
                  <User className="w-3 h-3 text-gold" />
                  <span className="text-white font-semibold text-sm">
                    {contact.name}
                  </span>
                </div>
                <span className={`text-xs px-2 py-1 rounded-full ${
                  contact.status === 'nouveau' 
                    ? 'bg-neon/20 text-neon' 
                    : 'bg-gray-500/20 text-gray-400'
                }`}>
                  {contact.status}
                </span>
              </div>
              <div className="flex items-center gap-2 text-xs text-gray-400">
                <Mail className="w-3 h-3" />
                <span className="truncate flex-1">{contact.project_type}</span>
                <span className="text-gold">{getTimeAgo(contact.timestamp)}</span>
              </div>
            </div>
          ))
        )}
      </CardContent>
    </Card>
  );
};
